import React, { FC } from 'react';
import {
  Button,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { updateUser } from '../../../store/admin/file-type-configuration/actions';
import useStyles from './styles';

const CustomButton: FC<any> = (properties: {
  row: {
    original: {
      catrecid: string;
    };
  };
}) => {
  const classes = useStyles();
  const {
    row: {
      original: { catrecid },
    },
  } = properties;

  const dispatch = useDispatch();

  const acceptRevoke = () => {
    dispatch(updateUser({ catrecId: catrecid }));
  };

  return (
    <Button
      className={classes.button}
      variant="outlined"
      color="primary"
      onClick={acceptRevoke}
    >
      Revoke User
    </Button>
  );
};

export default CustomButton;
